import axios from 'axios';
import CryptoJS from 'crypto-js';
import { handleFetchResponse } from '@/utils/fetchResponse';
import store from '@/store';
import { lmStudioTranslate } from '@/api/lmStudioTranslate';
import {
  tokenHubResponsesTranslate,
  tokenHubTranslate,
} from '@/api/tokenHubTranslate';
import {
  getTranslationOptions,
  TRANSLATION_PROVIDER_LLM,
  TRANSLATION_PROVIDER_TOKENHUB,
  TRANSLATION_PROVIDER_TOKENHUB_RESPONSES,
} from '@/utils/translationSettings';

// 从有道智云获取的APP_KEY和APP_SECRET
const APP_KEY = '15cc573c7cf53ffb';
const APP_SECRET = 'rYIwtkPp0bNqUWf4ywZemGTBxpjpYjmi';

const YOUDAO_URL = 'https://chat.pdwork.org/translate-api';

export function youdaoTranslate(text, from = 'auto', to = 'auto') {
  return new Promise((resolve, reject) => {
    if (!text) {
      resolve('');
      return;
    }

    const salt = Date.now();
    const curtime = Math.round(Date.now() / 1000);
    const str = APP_KEY + truncate(text) + salt + curtime + APP_SECRET;
    const sign = CryptoJS.SHA256(str).toString(CryptoJS.enc.Hex);

    const params = {
      q: text,
      appKey: APP_KEY,
      salt: salt,
      from: from,
      to: to,
      sign: sign,
      signType: 'v3',
      curtime: curtime,
    };

    axios
      .get(YOUDAO_URL, { params })
      .then((response) => {
        if (response.data.errorCode === '0') {
          resolve(response.data.translation[0]);
        } else {
          reject(new Error(getErrorMsg(response.data.errorCode)));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function truncate(q) {
  const len = q.length;
  if (len <= 20) return q;
  return q.substring(0, 10) + len + q.substring(len - 10, len);
}

function getErrorMsg(errorCode) {
  const errorMap = {
    101: '缺少必填的参数',
    102: '不支持的语言类型',
    103: '翻译文本过长',
    104: '不支持的API类型',
    105: '不支持的签名类型',
    106: '不支持的响应类型',
    107: '不支持的传输加密类型',
    108: '应用ID无效',
    109: 'batchLog格式不正确',
    110: '无相关服务的有效实例',
    111: '开发者账号无效',
    113: 'q不能为空',
    201: '解密失败，可能为DES,BASE64,URLDecode的错误',
    202: '签名检验失败',
    203: '访问IP地址不在可访问IP列表',
    205: '请求的接口与应用的平台类型不一致',
    206: '因为时间戳无效导致签名校验失败',
    207: '重放请求',
    301: '辞典查询失败',
    302: '翻译查询失败',
    303: '服务端的其它异常',
    304: '会话闲置太久超时',
    401: '账户已经欠费停',
    402: 'offlinesdk不可用',
    411: '访问频率受限,请稍后访问',
    412: '长请求过于频繁，请稍后访问',
  };
  return errorMap[errorCode] || '未知错误';
}

async function translateWithYoudaoFallback(translateFn, label, text, from, to) {
  try {
    return await translateFn(text, from, to);
  } catch (error) {
    console.warn(`${label}翻译失败，尝试有道兜底:`, error);
    return youdaoTranslate(text, from, to);
  }
}

function translateWithSelectedProvider(text, from, to, provider) {
  if (provider === TRANSLATION_PROVIDER_TOKENHUB) {
    return translateWithYoudaoFallback(tokenHubTranslate, 'TokenHub', text, from, to);
  }
  if (provider === TRANSLATION_PROVIDER_TOKENHUB_RESPONSES) {
    return translateWithYoudaoFallback(
      tokenHubResponsesTranslate,
      'TokenHub Responses',
      text,
      from,
      to
    );
  }
  if (provider === TRANSLATION_PROVIDER_LLM) {
    return translateWithYoudaoFallback(lmStudioTranslate, '大模型', text, from, to);
  }
  return youdaoTranslate(text, from, to);
}

export function translate(text, from = 'auto', to = 'auto', options = {}) {
  const settings = getTranslationOptions();
  const provider = options.provider || settings.provider;
  return translateWithSelectedProvider(text, from, to, provider);
}

export function datingTranslate(
  text,
  from = 'auto',
  to = 'auto',
  platformUserId
) {
  console.log('platformUserId', platformUserId);
  const userInfo = store.getters['socket/getUserInfo'](platformUserId);
  return new Promise((resolve, reject) => {
    let datingToLang = to.split('-')[0];
    fetch('https://api.dating.com/v2/translate', {
      method: 'POST',
      body: JSON.stringify({
        texts: [text],
        'target-language': datingToLang,
        'source-language': from,
      }),
      headers: {
        Authorization: 'Token token="' + userInfo.token + '"',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      handleFetchResponse(
        response,
        (res) => {
          resolve(res.translations[0].text);
        },
        (err) => {
          // 如果dating翻译失败，则使用有道翻译
          youdaoTranslate(text, from, to)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        }
      );
    });
  });
}
